import { swiperCreateNew } from "./swiper-settings";
import domReady from "@wordpress/dom-ready";

const initSwipers = () => {
	const allCarouselSections = document.querySelectorAll(
		".wp-block-theme-blocks-slider-images",
	);
	allCarouselSections?.forEach((section) => {
		const thisSwiper = swiperCreateNew(section.id);
	});
};

domReady(() => {
	initSwipers();
});
